import React from 'react';
import { faUtensils, faGlobeAsia, faLeaf } from '@fortawesome/free-solid-svg-icons';
import './About.css';
import AboutSection from './components/AboutSection.js';
import about1 from '../../../assets/crinkled-dark-background.jpg'; // Ensure the path to your image is correct
import about2 from '../../../assets/about2.png'; // Ensure the path to your image is correct
import about3 from '../../../assets/about3.png';
import about4 from '../../../assets/about4.png';
import about5 from '../../../assets/about5.png';

const About = () => {
  return (
    <>
      <AboutSection 
        icon={faUtensils}
        backgroundImage={about5}
        title="About Us"
        text="We believe in the power of good food to bring people together. Our restaurant is a celebration of Asian culinary traditions, offering a cozy and welcoming atmosphere where you can enjoy a meal with family and friends. Our team is committed to providing excellent service and a dining experience that you'll remember. Come and discover why Taste of Asia is a favorite among locals and visitors alike."
      />
      <AboutSection 
        icon={faGlobeAsia}
        backgroundImage={about3}
        title="Taste of Asia"
        text="Our menu is a journey through the diverse and rich flavors of Asia. From the bold and spicy dishes of Thailand to the delicate and refined tastes of Japan, we offer something for every palate. Each dish is prepared with the freshest ingredients and traditional techniques, ensuring an authentic taste experience. Join us at Taste of Asia and explore the culinary wonders of the continent, all in one place."
      />
      <AboutSection 
        icon={faLeaf}
        backgroundImage={about2}
        title="Authenticity at your palate"
        text="Experience the true essence of Asian cuisine with every bite. At Taste of Asia, our chefs bring you an array of dishes that stay true to their roots. Using time-honored techniques and the freshest ingredients, we ensure that you savor the genuine flavors of Asia. Whether it's the fiery spices of Thai food, the refined elegance of Japanese sushi, or the comforting warmth of Chinese cuisine, we promise an authentic dining experience that will leave your palate delighted."
      />
    </>
  );
};

export default About;
